import biLogger from 'web-bi-logger';


//call bi.updateDefaults to override some of these
export default biLogger.factory({endpoint: 'engage'}).setDefaults({src: 5}).logger();



// WEBPACK FOOTER //
// ./chat-app/biLogger/biLogger.config.js